export const tableData = (t) => [
  {
    name: t('common.description'),
    dataBase: 'name',
  },
];

//SOme
